import commodity from './commodity'
import history from './history'
import category from './category'

export default {
  commodity,
  history,
  category
}
